import { useCallback, useState } from 'react';
import { TextField, InputAdornment, CircularProgress } from '@mui/material';

import { useStepValidator } from 'Hooks/useStepValidator';
import { INPUT_STEP_NAMES } from 'Pages/Inputs/constants';
import { useInputStore } from 'Store';

const validatePostcode = (postcode) => {  
    postcode = postcode.replace(/\s/g, "");
    var regex = /^[A-Z]{1,2}[0-9]{1,2} ?[0-9][A-Z]{2}$/i;
    return regex.test(postcode);
}

// TODO: add validation to check google maps API success before proceeding

export const Postcode = () => {
    const postcode = useInputStore(state => state.postcode);
    const setValue = useInputStore((state) => state.set_value);

    const [error, setError] = useState(false);
    const [timerId, setTimerId] = useState(null);

    // validation
    const isValidPostcode = useCallback(() => validatePostcode(postcode), [postcode]);
  
    useStepValidator(INPUT_STEP_NAMES.location, 'postcode', isValidPostcode);

    // TODO: handle debounce with new validation
    const handleChange = (event) => {
        const value = event.target.value;
        setValue({ "postcode": value });

        if (timerId) {
            clearTimeout(timerId);
            setTimerId(null);
        }
        if (value === "") {
            setError(false);
            clearTimeout(timerId);
            return;
        }   
        const newTimerId = setTimeout(() => {
            const valid = validatePostcode(value);
            setError(!valid);
            setTimerId(null);
        }, 1500); 
        setTimerId(newTimerId);
    };

    return (
        <TextField
            size="small"
            label="Post Code"
            value={postcode}
            onChange={handleChange}
            error={error}
            helperText={error ? "Invalid postcode format" : ""}
            InputProps={{
                endAdornment: timerId && (
                    <InputAdornment position="end">
                        <CircularProgress size={20} />
                    </InputAdornment>
                ),
            }}
        />
    );
};

